module.exports = __webpack_public_path__ + "static/media/davide.3f62e469.png";